import { parse } from '../utils/phonenumber'

export default async function isPhone (value) {
  if (!value) return false
  const parsed = await parse(value)
  if (!parsed) return false
  return (parsed.country === 'US' && parsed.nationalNumber.length === 10) || parsed.country === 'BG'
}
